export const ROUTE_NAMES = Object.freeze({
  PAGES: {
    NOT_FOUND: "/404",
    HOME: "/",
    LOGIN: "/login",
    REGISTER: "/register",
    JOBS: "/jobs",
    VERIFY_EMAIL: "/verify-email",
    POST_JOB: "/post-job",
    EDIT_JOB: "/edit-job/:id",
    DASHBOARD: "/dashboard",
    PROFILE: "/profile",
    JOB_DETAILS: "/jobs",
    COMPANY_PROFILE: "/companies/:id",
    ABOUT: "/about",
    CONTACT: "/contact",
    PRIVACY: "/privacy",
    TERMS: "/terms",
    GDPR: "/gdpr",
    USER_PROFILE: "/user-profile",
    EMPLOYER_DASHBOARD: "/employer-dashboard",
    JOB_SEEKER_DASHBOARD: "/job-seeker-dashboard",
    EMPLOYEE_ONBOARDING: "/employee-onboarding",
    EMPLOYER_ONBOARDING: "/employer-onboarding",
    // Payment routes - commented out (project is free to use at start)
    // PRICING: "/pricing",
    // BILLING: "/billing",
    // PAYMENT_METHODS: "/payment-methods",
    // INVOICES: "/invoices",
    MESSAGES: "/messages",
    MY_APPLICATIONS: "/my-applications",
    FORGOT_PASSWORD: "/forgot-password",
    BLOG: "/blog",
    BLOG_ARTICLE: "/blog/:slug",
  },
});